"use client";

import * as React from "react";
import { Text, SectionCard, CardTitle, CardDescription, Section, Tabs, TabsContent, TabsList, TabsTrigger } from "@/src/components";

export default function DocsBlocksVerticalTabs() {
  return (
    <>
      <Section>
        <div className="space-y-4">
          <Text as="h1" className="text-h2 font-bold">
            Vertical Tabs
          </Text>
          <Text className="text-lg text-muted-foreground max-w-2xl">
            Tabs oriented vertically for sidebar-style navigation patterns.
          </Text>
        </div>
      </Section>

      <Section>
        <SectionCard
          header={
            <>
              <CardTitle>Example</CardTitle>
              <CardDescription>Vertical tabs with content</CardDescription>
            </>
          }
          contentClassName="p-6"
        >
          <Tabs defaultValue="general" orientation="vertical" className="flex gap-4">
            <TabsList className="flex flex-col h-auto bg-transparent border-r pr-4">
              <TabsTrigger value="general" className="justify-start">General</TabsTrigger>
              <TabsTrigger value="security" className="justify-start">Security</TabsTrigger>
              <TabsTrigger value="notifications" className="justify-start">Notifications</TabsTrigger>
              <TabsTrigger value="integrations" className="justify-start">Integrations</TabsTrigger>
            </TabsList>
            <div className="flex-1">
              <TabsContent value="general" className="mt-0">
                <div className="p-4 border rounded-lg">
                  <Text className="font-medium">General Settings</Text>
                  <Text className="text-sm text-muted-foreground mt-2">
                    Configure general application settings like language, timezone, and display preferences.
                  </Text>
                </div>
              </TabsContent>
              <TabsContent value="security" className="mt-0">
                <div className="p-4 border rounded-lg">
                  <Text className="font-medium">Security Settings</Text>
                  <Text className="text-sm text-muted-foreground mt-2">
                    Manage password, two-factor authentication, and session settings.
                  </Text>
                </div>
              </TabsContent>
              <TabsContent value="notifications" className="mt-0">
                <div className="p-4 border rounded-lg">
                  <Text className="font-medium">Notification Settings</Text>
                  <Text className="text-sm text-muted-foreground mt-2">
                    Choose which notifications you want to receive and how.
                  </Text>
                </div>
              </TabsContent>
              <TabsContent value="integrations" className="mt-0">
                <div className="p-4 border rounded-lg">
                  <Text className="font-medium">Integration Settings</Text>
                  <Text className="text-sm text-muted-foreground mt-2">
                    Connect third-party services and manage API access.
                  </Text>
                </div>
              </TabsContent>
            </div>
          </Tabs>
        </SectionCard>
      </Section>

      <Section>
        <SectionCard
          header={<CardTitle>Usage</CardTitle>}
          contentClassName="p-6"
        >
          <ul className="space-y-2 text-sm">
            <li>• Use for settings pages with multiple sections</li>
            <li>• Works well with longer tab labels</li>
            <li>• Good for forms with many fields grouped by category</li>
            <li>• Consider using icons alongside labels</li>
          </ul>
        </SectionCard>
      </Section>
    </>
  );
}
